import { WEBHOOK_FORMATS, type WebhookFormatKey } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Button, Field, Select } from "@sagot/ui";
import { suggestWebhookFormat } from "../settings-model";

const formatKey = (value: string): WebhookFormatKey | undefined => WEBHOOK_FORMATS.find((key) => key === value);

interface WebhookFormatFieldProps {
  url: string;
  value: WebhookFormatKey;
  error?: string | undefined;
  onChange: (format: WebhookFormatKey) => void;
}

/** Message-format select; offers the chat format when the URL is a Discord or Slack incoming webhook. */
export function WebhookFormatField({ url, value, error, onChange }: WebhookFormatFieldProps) {
  const { t } = useTranslation();
  const suggestion = suggestWebhookFormat(url);
  const suggested = suggestion !== null && suggestion !== value ? t(`settings.webhooks.formats.${suggestion}`) : null;
  return (
    <div className="space-y-2">
      <Field label={t("settings.webhooks.format")} hint={t(`settings.webhooks.formatHint.${value}`)} error={error}>
        <Select value={value} onChange={(event) => { onChange(formatKey(event.target.value) ?? value); }}>
          {WEBHOOK_FORMATS.map((key) => (
            <option key={key} value={key}>
              {t(`settings.webhooks.formats.${key}`)}
            </option>
          ))}
        </Select>
      </Field>
      {suggestion !== null && suggested !== null ? (
        <p className="flex flex-wrap items-center gap-2 rounded-md bg-surface-2 px-3 py-2 text-xs text-fg-muted" role="status">
          {t("settings.webhooks.formatSuggest", { format: suggested })}
          <Button variant="secondary" size="sm" onClick={() => { onChange(suggestion); }}>
            {t("settings.webhooks.formatUse", { format: suggested })}
          </Button>
        </p>
      ) : null}
    </div>
  );
}
